module.exports = {
      id: "house-usage",
      viewBox: "0 0 19 19.2",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#house-usage",
      toString: function () {
        return this.url;
      }
    }